import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { QuestionFormModel } from '../models/question-detail.model';
import { SearchQuestionsParams } from '../models/parent-question.model';
import { QuestionActions } from './question.actions';

@Injectable({ providedIn: 'root' })
export class QuestionActionsFacade {
  private readonly _store = inject(Store);

  public loadQuestions(): void {
    this._store.dispatch(QuestionActions.loadQuestions());
  }

  public setSearch(search: string): void {
    this._store.dispatch(QuestionActions.setSearch({ search }));
  }

  public selectQuestion(id: number): void {
    this._store.dispatch(QuestionActions.selectQuestion({ id }));
  }

  public deselectQuestion(): void {
    this._store.dispatch(QuestionActions.deselectQuestion());
  }

  public createQuestion(model: QuestionFormModel): void {
    this._store.dispatch(QuestionActions.createQuestion({ model }));
  }

  public updateQuestion(id: number, model: QuestionFormModel): void {
    this._store.dispatch(QuestionActions.updateQuestion({ id, model }));
  }

  public deleteQuestion(id: number): void {
    this._store.dispatch(QuestionActions.deleteQuestion({ id }));
  }

  public deleteLocalization(questionId: number, locale: string): void {
    this._store.dispatch(
      QuestionActions.deleteLocalization({ questionId, locale }),
    );
  }

  public loadCompanies(): void {
    this._store.dispatch(QuestionActions.loadCompanies());
  }

  public loadCategories(): void {
    this._store.dispatch(QuestionActions.loadCategories());
  }

  public resetState(): void {
    this._store.dispatch(QuestionActions.resetState());
  }

  public searchParentQuestions(params: SearchQuestionsParams): void {
    this._store.dispatch(QuestionActions.searchParentQuestions({ params }));
  }

  public searchChildQuestions(params: SearchQuestionsParams): void {
    this._store.dispatch(QuestionActions.searchChildQuestions({ params }));
  }
}
